import {
  SET_FETCHING_TEAM_MEMBERS,
  SET_TEAM_MEMBERS,
} from '../actions/team-members.js';

const INITIAL_STATE = {
  members: [],
  fetching: false,
};

const teamMembersReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_TEAM_MEMBERS:
      return {
        ...state,
        members: action.members,
      };

    case SET_FETCHING_TEAM_MEMBERS: {
      return {
        ...state,
        fetching: action.fetching,
      };
    }

    default:
      return state;
  }
};

export default teamMembersReducer;
